<!-- 企业级-无人仓业务-配置设置 -->
<template>
  <div class="mainArea CExpressOrder">
      
      <div class="searchDiv mt20 mb20">
        <div class="dib"><el-input placeholder="请输入快递单号" v-model="keyword.orderId" clearable @keyup.enter.native="getWarehouse(1)"></el-input></div>
        <div class="dib"><el-input placeholder="请输入设备ID" v-model="keyword.deviceId" clearable @keyup.enter.native="getWarehouse(1)"></el-input></div>
        <div class="dib"><el-input placeholder="请输入取件人手机号码" v-model="keyword.receiver_info" clearable @keyup.enter.native="getWarehouse(1)"></el-input></div>
        <el-select v-model="keyword.status" placeholder="请选择状态" clearable @change="getWarehouse(1)">
          <el-option label="已完成" value="S"></el-option>
          <el-option label="使用中" value="W"></el-option>
          <el-option label="已预约" value="V"></el-option>
          <el-option label="订单失败" value="F"></el-option>
          <el-option label="已退还" value="R"></el-option>
          <el-option label="已释放" value="B"></el-option>
          <el-option label="已过期" value="T"></el-option>
          <el-option label="已关闭" value="L"></el-option>
        </el-select>
        <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
      </div>
      <div class="tabList">
        <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
          <el-table-column fixed type="index" label="序号" width="100"></el-table-column>
          <el-table-column fixed prop="t_package_no" label="快递单号" sortable width="150"></el-table-column>
          <el-table-column prop="sender_name" label="存件人姓名" width="100"></el-table-column>
          <el-table-column prop="sender_phone" label="存件人手机号码" sortable width="150"></el-table-column>
          <!-- <el-table-column prop="reveiver_name" label="取件人姓名" width="100"></el-table-column> -->
          <el-table-column prop="receiver_phone" label="取件人手机号码" sortable width="150"></el-table-column>
          <el-table-column prop="device_type" label="设备类型" sortable width="150"></el-table-column>
          <el-table-column prop="device_no_id" label="设备ID" sortable width="150"></el-table-column>
          <el-table-column prop="device_name" label="设备名称" sortable width="150"></el-table-column>
          <el-table-column prop="box_number" label="存放箱格号" sortable width="120"></el-table-column>
          <el-table-column prop="open_password" label="取件码" sortable width="100"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" sortable width="200"></el-table-column>
          <el-table-column prop="end_time" label="取件时间" sortable width="200"></el-table-column>
          <el-table-column fixed='right' label="状态" sortable prop="order_status" width="100">
            <template slot-scope="scope">
              <el-button v-if="scope.row.order_status == 'S'" type="text" class="col67C">已完成</el-button>
              <el-button v-if="scope.row.order_status == 'W'" type="text" class="col666">使用中</el-button>
              <el-button v-if="scope.row.order_status == 'V'" type="text" class="col409">已预约</el-button>
              <el-button v-if="scope.row.order_status == 'F'" type="text" class="colF56">订单失败</el-button>
              <el-button v-if="scope.row.order_status == 'R'" type="text" class="colE6A">已退还</el-button>
              <el-button v-if="scope.row.order_status == 'B'" type="text" class="col00f">已释放</el-button>
              <el-button v-if="scope.row.order_status == 'T'" type="text" class="col00f">已过期</el-button>
              <el-button v-if="scope.row.order_status == 'L'" type="text" class="col666">已关闭</el-button>
            </template>
          </el-table-column>
          <el-table-column fixed='right' label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="relPayNum(scope.row.order_sn)" 
              v-if="scope.row.order_status == 'W' || scope.row.order_status == 'V'">释放订单</el-button>
              <el-button type="text" @click="relPayNum(scope.row.order_sn)" 
              v-else disabled="">释放订单</el-button>
            </template>
          </el-table-column>
          
        </el-table>
      </div>
      <div class="paging" v-if="total>page">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          @size-change="sizeChange"
          :page-size="page"
          :page-sizes="[10,50,100,1000]"
          layout="total,sizes,prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="提示" :visible.sync="relTrackNum" width="30%">
        <span>确认要释放订单？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="relTrackNum = false">取 消</el-button>
          <el-button type="primary" @click="relTrackNumOrder">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { bussinessApi,userApi } from "../../../../static/js/api.js"

  export default {
    name: 'CExpressOrder',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        relTrackNum: false,
        keyword:{
          orderId:'',//快递单号
          deviceId:'',//设备号
          receiver_info:'',//取件人或取件人姓名查询
          status:'',//快递状态
        },

        configList:[],//审核记录列表
        tableLoading:false,

        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        relform:{
          order_id:'',
        }
      };
    },
    mounted(){

    },
    created: async function () {
      this.getWarehouse()
    },
    methods: {
      //释放订单
      relPayNum(order_id){
        this.relTrackNum = true
        this.relform.order_id = order_id
      },
       //确认释放订单
      async relTrackNumOrder(){
        let that = this;
        const data={
          'order_sn':this.relform.order_id,
        }
        const res = await bussinessApi.relTrackNum(data)
        if(res.meta.code == 200){
          that.relTrackNum = false
          that.getWarehouse()
          showToast('释放成功！')
        }else{
          showToast(res.meta.message)
        }
      },
      //获取快递员列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'order_sn': that.keyword.orderId,
          'device_no_id': that.keyword.deviceId,//设备编号
          'receiver_info': that.keyword.receiver_info,
          'order_status': that.keyword.status,
        }
        let res = await bussinessApi.getCourierOrderList(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getWarehouse(val)
      },
      sizeChange (val) {
        console.log('val', val)
        this.page = val
        this.getWarehouse(1)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CExpressOrder{
  .fs25{
    font-size:25px;
  }
  .flexItem{
    flex-grow: 1;
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
  .col67C{
    color: #67C23A;
  }
  .col666{
    color: #666;
  }
  .col409{
    color: #409EFF;
  }
  .colE6A{
    color: #E6A23C;
  }
  .colF56{
    color: #F56C6C;
  }
  .col00f{
    color: #00ffe9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CExpress/CExpressOrder.vue